// Availability ingestion shares the ingestion lifecycle with lease ingestion
// (backend: `IngestionStatus` in `ingestion-shared/status.ts`). Values match the
// API exactly.
export enum AvailabilityIngestionStatusEnum {
  Uploaded = 'uploaded',
  Extracting = 'extracting',
  ExtractionFailed = 'extraction_failed',
  PendingReview = 'pending_review',
  Rejected = 'rejected',
  Approved = 'approved',
  Writing = 'writing',
  WriteFailed = 'write_failed',
  Written = 'written',
}

export enum AvailabilityIngestionExtractionFailureReasonEnum {
  ImageOnlyPdfNeedsOcr = 'image_only_pdf_needs_ocr',
  EmptyDocument = 'empty_document',
  LlmError = 'llm_error',
  SchemaValidationFailed = 'schema_validation_failed',
  Unknown = 'unknown',
}

export const AVAILABILITY_INGESTION_NON_TERMINAL_STATUSES: AvailabilityIngestionStatusEnum[] = [
  AvailabilityIngestionStatusEnum.Uploaded,
  AvailabilityIngestionStatusEnum.Extracting,
  AvailabilityIngestionStatusEnum.Approved,
  AvailabilityIngestionStatusEnum.Writing,
];

// How a candidate Property's address compares to the flyer's extracted address
// (backend: `AddressMatchKind` in `ingestion-shared/interfaces/property-resolver.interface.ts`).
export enum AvailabilityPropertyMatchEnum {
  Exact = 'exact',
  Likely = 'likely',
}

// Structured `code` the approve endpoint returns on a 409/400 refusal
// (backend: `PROPERTY_CHOICE_REQUIRED` / `PROPERTY_ADDRESS_INCOMPLETE` in
// `availability-ingestion/approve/approval-target.ts`).
export enum AvailabilityApproveErrorCodeEnum {
  PropertyChoiceRequired = 'property_choice_required',
  PropertyAddressIncomplete = 'property_address_incomplete',
}

// How approving handles one extracted broker (chosen in the page's Contacts card). `Auto` is the backend
// default (reuse the contact with the same email, else create one) — the
// request only carries `Existing` / `Skip` decisions. Brokers already matched
// to a contact start as `Existing`, so `Auto` in practice means "create new".
export enum AvailabilityBrokerContactModeEnum {
  Auto = 'auto',
  Existing = 'existing',
  Skip = 'skip',
}

// How the backend matched an extracted broker to an existing contact
// (backend: `BrokerContactMatchKind` in `availability-ingestion/interfaces`).
export enum AvailabilityBrokerContactMatchEnum {
  Email = 'email',
  Name = 'name',
}
